export const SIGNUP_STEPS = [
  {
    id: 'contact',
    title: 'Datos de contacto',
  },
  {
    id: 'avatar',
    title: 'Foto',
  },
  {
    id: 'access',
    title: 'Acceso',
  },
];

export const SIGNUP_INITIAL_STATE = {
  avatar: null,
  avatarPreview: '',
  name: '',
  phone: '',
  email: '',
  password: '',
};
